import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    data(){
      return {
        loading: false,
        orderId: null,
        country: 'USA',
        successMessage: ''
      }
    },
    methods: {
      submitVin(){
        this.loading = true
        const formData = Object.fromEntries(new FormData(this.$refs.vinForm).entries())
        jQuery.ajax({
          url: this.$refs.adminUrl.value,
          data: formData,
          complete: res => {
            this.loading = false
            if(res?.responseJSON?.data?.error_message){
              alert(res.responseJSON.data.error_message)
            } else {
              if(res?.responseJSON?.data?.order_id){
                this.orderId = res.responseJSON.data.order_id
              } else {
                alert("Unexpected response from API. Please try again later.")
              }
            }
          }
        })
      },
      submitCustomerInfo(){
        this.loading = true
        const formData = Object.fromEntries(new FormData(this.$refs.customerForm).entries())
        jQuery.ajax({
          url: this.$refs.adminUrl.value,
          data: formData,
          complete: res => {
            this.loading = false
            if(res?.responseJSON?.data?.error_message){
              alert(res.responseJSON.data.error_message)
            } else {
              if(res?.responseJSON?.data?.success_message){
                this.successMessage = res.responseJSON.data.success_message
              } else {
                alert("Unexpected response from API. Please try again later.")
              }
            }
          }
        })
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.aev-registry')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig, { el })
        app.mount(el)
      })
    }
  }

  initApp()
}